import { render } from "./Path3DPopup.vue?vue&type=template&id=47686b30&scoped=true&ts=true"
import script from "./Path3DPopup.vue?vue&type=script&lang=ts"
export * from "./Path3DPopup.vue?vue&type=script&lang=ts"

import "./Path3DPopup.vue?vue&type=style&index=0&id=47686b30&scoped=true&lang=scss"
import "./Path3DPopup.vue?vue&type=style&index=1&id=47686b30&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47686b30"]])

export default __exports__